export default __webpack_public_path__ + "static/media/saleshandy-logo.ef83e702.svg";